//import { getUserData } from 'app/store/actions/user/user.actions';
import axios from 'axios';
//import history from '@history';

export const GET_MEMBERS = '[MEMBERS APP] GET MEMBERS';
export const RESET_GET_MEMBERS = '[MEMBERS APP RESET MEMBERS]';
export const MEMBER_SEARCH_TEXT = '[MEMBERS APP] MEMBER SEARCH TEXT';
export const OPEN_NEW_CONTACT_DIALOG = '[MEMBERS APP] OPEN NEW CONTACT DIALOG';
export const CLOSE_NEW_CONTACT_DIALOG = '[MEMBERS APP] CLOSE NEW CONTACT DIALOG';
export const OPEN_EDIT_CONTACT_DIALOG = '[MEMBERS APP] OPEN EDIT CONTACT DIALOG';
export const CLOSE_EDIT_CONTACT_DIALOG = '[MEMBERS APP] CLOSE EDIT CONTACT DIALOG';
export const ADD_CONTACT = '[MEMBERS APP] ADD CONTACT';
export const UPDATE_CONTACT = '[MEMBERS APP] UPDATE CONTACT';
export const REMOVE_CONTACT = '[MEMBERS APP] REMOVE CONTACT';
export const REMOVE_CONTACTS = '[MEMBERS APP] REMOVE CONTACTS';
export const TOGGLE_STARRED_CONTACT = '[MEMBERS APP] TOGGLE STARRED CONTACT';
export const TOGGLE_STARRED_CONTACTS = '[MEMBERS APP] TOGGLE STARRED CONTACTS';
export const SET_CONTACTS_STARRED = '[MEMBERS APP] SET CONTACTS STARRED ';
export const HANDLE_DATA_DETAILS = '[MEMBERS APP] HANDLE DATA DETAILS ';
export const PROJECT_SEARCH_TEXT = '[MEMBERS APP] PROJECT SEARCH TEXT';
export const SET_FILTER_CHECKBOX = '[MEMBERS APP] FILTER CHECKBOX';
export const HANDLING_FILTERED_DATA = '[MEMBERS APP] HANDLING FILTERED DATA';
export const STATUS_MEMBER = '[MEMBERS APP] CHANGING CURRENT STATUS MEMBER';
export const GET_PUBLIC_MEMBER_TYPE = '[MEMBER APP] GET PUBLIC MEMBER TYPE';
export const GET_PUBLIC_GROUP_TYPE = '[MEMBER APP] GET_PUBLIC_GROUP_TYPE';
export const GET_PUBLIC_USER_POSITION = '[MEMBER APP] GET_PUBLIC_USER_POSITION';
export const GET_PUBLIC_AFFILIATION = '[MEMBER APP] GET_PUBLIC_AFFILIATION';
export const GET_PRIVATE_MEMBER_TYPE = '[MEMBER APP] GET PRIVATE MEMBER TYPE';
export const GET_PRIVATE_GROUP_TYPE = '[MEMBER APP] GET_PRIVATE_GROUP_TYPE';
export const GET_PRIVATE_AFFILIATION = '[MEMBER APP] GET_PRIVATE_AFFILIATION';
export const GET_PRIVATE_USER_POSITION = '[MEMBER APP] GET_PRIVATE_USER_POSITION';
export const CREATE_MEMBER = '[MEMBER APP] CREATE USER MEMBER';
export const UPDATE_MEMBER = '[MEMBER APP] UPDATE USER MEMBER';
export const HANDLE_MEMBERS_RESPONSE = '[MEMBERS APP] HANDLING RESPONSE API';
export const MEMBERS_COMPANY_DETAILS = '[MEMBERS APP] HANDLING MEMBERS COMPANY DETAILS';
export const HANDLE_MEMBERS_PROJECT_SELECTED = '[MEMBERS APP] HANDLING MEMBERS PROJECTED SELECTED';
export const MEMBERS_GET_PROJECT_BRANCH = '[MEMBERS APP] GET PROJECT BRANCH';
export const MEMBERS_GET_PROJECTS = '[MEMBERS APP] GET ALL PROJECTS';
export const MEMBERS_SELETED_PROJECTNAME = '[MEMBERS APP] SELECTED PROJECT NAME';
export const GET_MEMBERS_MAPPING = '[MEMBERS MAPING APP] GET MEMBERS MAPPING';
export const ADD_MEMBER_MAPPING = '[MEMBERS MAPPING APP] ADD USERS MEMBERS MAPPING';
export const REMOVE_USER_FROM_PROJECT_SELECTED = '[MEMBERS MAPPING APP] REMOVE USERS FROM PROJECT';
export const REMOVE_PROJECT_FROM_MEMBER = '[MEMBERS MAPPING APP] REMOVE PROJECT FROM MEMBER';
export const HANDLING_RESPONSE_MEMBERS_PAGE = '[MEMBERS MAPPING APP] HANDLING RESPONSE MEMBERS PAGE';
export const MEMBER_PAGE_CLICK_FLAG = '[MEMBERS MAPPING APP] HANDLING FLAG CLICK';
export const MEMBER_PAGE_REFRESH_DATA_FLAG = '[MEMBERS MAPPING APP] REFRESHING DATA FLAG';

//:: Get Members
export function getMembers(dataCompanyID, projectUUID, pageData, _searchText) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		let localStoragePage = localStorage.getItem('pageData');
		let page = localStoragePage ? localStoragePage : 1;
		let searchText = _searchText;
		const companyID = dataCompanyID;
		let project_uuid = projectUUID;
		const headersToken = {
			'Content-Type': 'application/json',
			headers: { "Authorization": `Token ${token}` }
		};


		if (pageData) {
			page = pageData;
		}

		if (!searchText) {
			searchText = '';
		}

		if (project_uuid === undefined || project_uuid === null) {
			project_uuid = '';
		};

		const request = axios.get(process.env.REACT_APP_SERVER + '/api/projectMap/create-update-project-mapping?companyID=' + companyID + '&project_uuid=' + project_uuid + '&page=' + page + '&searchkey=' + searchText, headersToken);
		return request.then(response => {
			console.log('GET Members Succesfully', response.data);
			//console.log('ALL EMAILS', response.data.memberEmails);
			//history.push({ pathname: '/members' });
			return dispatch({
				type: GET_MEMBERS,
				payload: response.data,
			});
		}).catch(error => {
			console.log('Could not load data from members', error.response)
		})
	}
}

//:: Reset Get Members
export function resetGetMembers() {
	return {
		type: RESET_GET_MEMBERS,
	}
}

//::Activate and Deactivate Members
export function statusMember(data, statusMember, isDeleted) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: { "Authorization": `Token ${token}` }
		};
		console.log('STATUS MEMBER --->', data, statusMember, isDeleted)

		const request = axios.patch(process.env.REACT_APP_SERVER + '/api/member/create-update-member',
			{
				...data,
				companyID: data.companyID,
				usruId: data.uuid,
				status: statusMember,
				is_deleted: isDeleted,
			}, headersToken)

		return request.then(response => {
			console.log('Change Status Member Succesfully', response.data);
			dispatch(getMembers(data.companyID, data.project_uuid));
			dispatch(memberPageRefreshDataFlag(true));
			//history.push({ pathname: '/members' });
			return dispatch({
				type: STATUS_MEMBER,
				payload: response.data,
			});
		}).catch(error => {
			console.log('Could not change status from members', error.response)
		})
	}
}

//::Create Member
export function createMember(data, companyIDdata) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: { "Authorization": `Token ${token}` }
		};
		//console.log('INSIDE CREATE ACTIONS ==', data , companyIDdata);
		const request = axios.post(process.env.REACT_APP_SERVER + '/api/member/create-update-member', {
			...data,
			// user: loggedUser.id,
			companyID: companyIDdata,
		}, headersToken);

		return request.then((response) => {
			console.log('User Member Created Succesfully!', response.data);
			dispatch(handlingResponseMembersPage(true));
			dispatch(memberPageRefreshDataFlag(true));
			//::Force Update Consume API
			dispatch(getMembers(companyIDdata, ''));

			return dispatch({
				type: CREATE_MEMBER,
				payload: data,
			})
		})
			.catch((error => {
				dispatch(addPostMember(error.response));
				dispatch(handlingResponseMembersPage(false));
				console.log('Error, could not Create User Member.', error.response);
			}))
	}
}

//::Update Member
export function updateMember(data, companyIDdata, projectUUID) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];

		let project_uuid = projectUUID;
		if (project_uuid === undefined) {
			project_uuid = '';
		};
		const headersToken = {
			'Content-Type': 'application/json',
			headers: { "Authorization": `Token ${token}` }
		};
		console.log('INSIDE UPDATE ACTIONS ==', data, companyIDdata);
		const request = axios.put(process.env.REACT_APP_SERVER + '/api/member/create-update-member', {
			...data,
			companyID: companyIDdata,
		}, headersToken);

		return request.then((response) => {
			console.log('User Member Updated Succesfully!', response.data);
			//::Force Update Consume API
			dispatch(getMembers(companyIDdata, project_uuid));
			dispatch(handlingResponseMembersPage(true));
			dispatch(memberPageRefreshDataFlag(true));
			return dispatch({
				type: UPDATE_MEMBER,
				payload: data,
			})
		})
			.catch((error => {
				console.log('Error, could not Update User Member.', error.response);
				dispatch(handlingResponseMembersPage(false));
			}))
	}
}

//::Get Member Type Public
export function getMemberTypePublic() {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		let memberTypeId = current_user['membertype']['id'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: { "Authorization": `Token ${token}` }
		};
		const request = axios.get(process.env.REACT_APP_SERVER + '/api/common/member-type-public', headersToken);
		return request.then(response => {
			/*
			let memberTypes = response.data;

			// ユーザーの権限に基づいてフィルタリング
			if (memberTypeId === 3 || memberTypeId === 4) {
				memberTypes = memberTypes.filter(type => type.id !== 6);
			}
				*/
			console.log('Get Public Member Type succesfully', response.data);

			return dispatch({
				type: GET_PUBLIC_MEMBER_TYPE,
				payload: response.data,
			});

		}).catch(error => {
			console.log('Error, Cold not get Member Type', error.response)
		})
	}
}

//::Get Member Type Private
export function getMemberTypePrivate(data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: { "Authorization": `Token ${token}` }
		};

		const companyID = data;
		const request = axios.get(process.env.REACT_APP_SERVER + '/api/common/member-type-private?companyID=' + companyID, headersToken);
		return request.then(response => {
			console.log('Get Private Member Type succesfully', response.data);
			return dispatch({
				type: GET_PRIVATE_MEMBER_TYPE,
				payload: response.data,
			});

		}).catch(error => {
			console.log('Error, Cold not get Private Member Type', error.response)
		})
	}
}

//::Get Group Type Public
export function getGroupTypePublic() {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: { "Authorization": `Token ${token}` }
		};
		const request = axios.get(process.env.REACT_APP_SERVER + '/api/common/group-type-public', headersToken);
		return request.then(response => {
			console.log('Get Public Group Type succesfully', response.data);
			return dispatch({
				type: GET_PUBLIC_GROUP_TYPE,
				payload: response.data,
			});

		}).catch(error => {
			console.log('Error, Cold not get Group Type', error.response)
		})
	}
}

//::Get Group Type Private
export function getGroupTypePrivate(data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: { "Authorization": `Token ${token}` }
		};
		console.log('COMPANY ID FROM GROUP TYPE', data)
		const companyID = data;
		const request = axios.get(process.env.REACT_APP_SERVER + '/api/common/group-type-private?companyID=' + companyID, headersToken);
		return request.then(response => {
			console.log('Get Private Group Type succesfully', response.data);
			return dispatch({
				type: GET_PRIVATE_GROUP_TYPE,
				payload: response.data,
			});

		}).catch(error => {
			console.log('Error, Cold not get Private Group Type', error.response)
		})
	}
}

//::Get User Position Public
export function getUserPositionPublic() {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: { "Authorization": `Token ${token}` }
		};
		const request = axios.get(process.env.REACT_APP_SERVER + '/api/common/user-position-public', headersToken);
		return request.then(response => {
			console.log('Get Public User Position succesfully', response.data);
			return dispatch({
				type: GET_PUBLIC_USER_POSITION,
				payload: response.data,
			});

		}).catch(error => {
			console.log('Error, Cold not get User Position', error.response)
		})
	}
}

//::Get User Position Private
export function getUserPositionPrivate(data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: { "Authorization": `Token ${token}` }
		};
		const companyID = data;
		const request = axios.get(process.env.REACT_APP_SERVER + '/api/common/position-private?companyID=' + companyID, headersToken);
		return request.then(response => {
			console.log('Get Private User Position succesfully', response.data);
			return dispatch({
				type: GET_PRIVATE_USER_POSITION,
				payload: response.data,
			});

		}).catch(error => {
			console.log('Error, Cold not get Private User Position', error.response)
		})
	}
}

//::Get Affiliation Type Public
export function getAffiliationPublic() {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: { "Authorization": `Token ${token}` }
		};
		const request = axios.get(process.env.REACT_APP_SERVER + '/api/common/affiliation-public', headersToken);
		return request.then(response => {
			console.log('Get Public Affiliation succesfully', response.data);
			return dispatch({
				type: GET_PUBLIC_AFFILIATION,
				payload: response.data,
			});

		}).catch(error => {
			console.log('Error, Cold not get Affiliation', error.response)
		})
	}
}

//::Get Affiliation Type Private
export function getAffiliationPrivate(data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: { "Authorization": `Token ${token}` }
		};
		const companyID = data;
		const request = axios.get(process.env.REACT_APP_SERVER + '/api/common/affiliation-private?companyID=' + companyID, headersToken);
		return request.then(response => {
			console.log('Get Private Affiliation succesfully', response.data);
			return dispatch({
				type: GET_PRIVATE_AFFILIATION,
				payload: response.data,
			});

		}).catch(error => {
			console.log('Error, Cold not get Private Affiliation', error.response)
		})
	}
}

//::Handling Response
export function addPostMember(data) {
	console.log('HANDLING REPONSE IN ACTIONS ==', data)
	return {
		type: HANDLE_MEMBERS_RESPONSE,
		payload: data,
	}
}

//::Handling Project Selected
export function handleMembers_projectSelected(data) {
	return async (dispatch) => {
		dispatch(memberPageRefreshDataFlag(true));
		return dispatch({
			type: HANDLE_MEMBERS_PROJECT_SELECTED,
			payload: data,
		}
		)
	}
}


//::Get Project Branch
export function members_getProjectBranch(data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: { "Authorization": `Token ${token}` }
		};

		const companyID = data
		const request = axios.get(process.env.REACT_APP_SERVER + '/api/common/common-type-private?companyID=' + companyID + '&type=ProjectBranch', headersToken)

		return request.then(response => {
			//console.log('Load Initialization - Project Branch Succesfully', response.data);
			return dispatch({
				type: MEMBERS_GET_PROJECT_BRANCH,
				payload: response.data,
			});
		}).catch(error => {
			//console.log('Could not load data from Initialization - Project Branch Error', error);
		})
	};
}


//::GET Projects
export function members_getProjects(data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: { "Authorization": `Token ${token}` }
		};
		const companyID = data;

		const request = axios.get(process.env.REACT_APP_SERVER + '/api/project/create-update-project?companyID=' + companyID, headersToken);

		return request.then(response => {
			//history.push({ pathname: '/members' });
			return dispatch({
				type: MEMBERS_GET_PROJECTS,
				payload: response.data.data,
			});
		}).catch(error => {
			//console.log('Could not load data from PROJECTS', error.response)
		})
	}
}

//::Selected Project Name
export function members_selectedProjectName(data) {
	return {
		type: MEMBERS_SELETED_PROJECTNAME,
		payload: data,
	}
}

//::Get Users from Mapping
export function getMembersMapping(companyIDdata, projectUUID) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: { "Authorization": `Token ${token}` }
		};
		const companyID = companyIDdata;
		let project_uuid = projectUUID;
		if (project_uuid === undefined || project_uuid === null) {
			project_uuid = '';
		};

		const request = axios.get(process.env.REACT_APP_SERVER + '/api/projectMap/create-update-project-mapping?companyID=' + companyID + '&project_uuid=' + project_uuid, headersToken)

		return request.then(response => {
			console.log('GET Mapping Members Succesfully', response.data);

			return dispatch({
				type: GET_MEMBERS_MAPPING,
				payload: response.data,
			});
		}).catch(error => {
			console.log('Could not load data from Mapping Members', error.response)
		})
	}
}

//::Post Add Users from Mapping
export function addMemberMapping(data, companyIDdata, projectUUIDdata) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: { "Authorization": `Token ${token}` }
		};
		const companyID = companyIDdata;
		const project_uuid = projectUUIDdata;
		const users = data;

		console.log('INSIDE ACTIONS DATA MAPPING', data)

		const request = axios.post(process.env.REACT_APP_SERVER + '/api/projectMap/create-update-project-mapping',
			{
				companyID: companyID,
				project_uuid: project_uuid,
				users: users
			}, headersToken);

		return request.then((response) => {
			console.log('Added Users Members Mapping Succesfully!', response.data);
			dispatch(handlingResponseMembersPage(true));
			dispatch(memberPageRefreshDataFlag(true));
			//::Force Update Consume API
			dispatch(getMembers(companyIDdata, projectUUIDdata));

			return dispatch({
				type: ADD_MEMBER_MAPPING,
				payload: data,
			})
		})
			.catch((error => {
				dispatch(addPostMember(error.response));
				dispatch(handlingResponseMembersPage(false));
				console.log('Error, could not Add Users Member Mapping.', error.response);
			}))
	}
}

//::Remove User from Project Selected - From Options
export function removeUserFromProjectSelected(data, projectUUID) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: { "Authorization": `Token ${token}` }
		};
		// console.log('DATA INSIDE REMOVE : ', data, projectUUID);
		const request = axios.patch(process.env.REACT_APP_SERVER + '/api/projectMap/create-update-project-mapping',
			{
				...data,
				companyID: data.companyID,
				user_uuid: data.uuid,
				project_uuid: projectUUID,
			}, headersToken)

		return request.then(response => {
			console.log('Removed from Project Succesfully', response.data);

			dispatch(getMembers(data.companyID, projectUUID));
			dispatch(handlingResponseMembersPage(true));
			//history.push({ pathname: '/members' });
			return dispatch({
				type: REMOVE_USER_FROM_PROJECT_SELECTED,
				payload: response.data,
			});
		}).catch(error => {
			dispatch(handlingResponseMembersPage(false));
			console.log('Could not be Removed from Project', error)
		})
	}
}

//::Remove Project from Member - From SideBar
export function removeProjectFromMember(data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		let persistProjectUUID = localStorage.getItem('persistProjectUUID');
		const headersToken = {
			'Content-Type': 'application/json',
			headers: { "Authorization": `Token ${token}` }
		};

		const request = axios.patch(process.env.REACT_APP_SERVER + '/api/projectMap/create-update-project-mapping',
			{
				...data,
				companyID: data.companyID,
				user_uuid: data.uuid,
				project_uuid: data.projectUUID,
			}, headersToken)

		return request.then(response => {
			console.log('Project was Removed Succesfully', response.data);
			dispatch(handlingResponseMembersPage(true));

			//::Checking if inside Project or not to Update data
			(persistProjectUUID && persistProjectUUID !== null) ?
				dispatch(getMembers(data.companyID, persistProjectUUID))
				:
				dispatch(getMembers(data.companyID, ''));

			return dispatch({
				type: REMOVE_PROJECT_FROM_MEMBER,
				payload: response.data,
			});

		}).catch(error => {
			dispatch(handlingResponseMembersPage(false));
			console.log('Could not Remove Project from Member', error);
		})
	}
}

//::Handling Response 
export function handlingResponseMembersPage(data) {
	return {
		type: HANDLING_RESPONSE_MEMBERS_PAGE,
		payload: data
	}
}

//Click Flag Members Page
export function memberPageClickFlag(data) {
	return {
		type: MEMBER_PAGE_CLICK_FLAG,
		payload: data
	}
}


export function memberPageRefreshDataFlag(data) {
	return {
		type: MEMBER_PAGE_REFRESH_DATA_FLAG,
		payload: data
	}
}


export function handlingFilteredData(data) {
	return {
		type: HANDLING_FILTERED_DATA,
		payload: data
	}
}

export function searchFilterCheckbox(data) {
	return {
		type: SET_FILTER_CHECKBOX,
		payload: data
	};
}

export function members_handleDataDetails(data) {
	console.log('COMPANY ID COMING FROM COMPANIES -->', data)
	return {
		type: HANDLE_DATA_DETAILS,
		payload: data
	};
}

export function members_companyDetails(data) {
	return {
		type: MEMBERS_COMPANY_DETAILS,
		payload: data
	};
}

//::Search Member
export function searchMember(event) {
	return async (dispatch) => {
		return dispatch({
			type: MEMBER_SEARCH_TEXT,
			searchMember: event.target.value
		});
	}

}

export function searchProject(event) {
	return {
		type: PROJECT_SEARCH_TEXT,
		searchProject: event.target.value
	};
}

export function openNewContactDialog() {
	return {
		type: OPEN_NEW_CONTACT_DIALOG
	};
}

export function closeNewContactDialog() {
	return {
		type: CLOSE_NEW_CONTACT_DIALOG
	};
}

export function openEditContactDialog(data) {
	return {
		type: OPEN_EDIT_CONTACT_DIALOG,
		data
	};
}

export function closeEditContactDialog() {
	return {
		type: CLOSE_EDIT_CONTACT_DIALOG
	};
}

// export function addContact(newContact) {
// 	return (dispatch, getState) => {
// 		const { routeParams } = getState().addmemberUsersApp.contacts;

// 		const request = axios.post('/api/contacts-app/add-contact', {
// 			newContact
// 		});

// 		return request.then(response =>
// 			Promise.all([
// 				dispatch({
// 					type: ADD_CONTACT
// 				})
// 			]).then(() => dispatch(getMembers(routeParams)))
// 		);
// 	};
// }

// export function updateContact(contact) {
// 	return (dispatch, getState) => {
// 		const { routeParams } = getState().addmemberUsersApp.contacts;

// 		const request = axios.post('/api/contacts-app/update-contact', {
// 			contact
// 		});

// 		return request.then(response =>
// 			Promise.all([
// 				dispatch({
// 					type: UPDATE_CONTACT
// 				})
// 			]).then(() => dispatch(getMembers(routeParams)))
// 		);
// 	};
// }

// export function removeContact(contactId) {
// 	return (dispatch, getState) => {
// 		const { routeParams } = getState().addmemberUsersApp.contacts;

// 		const request = axios.post('/api/contacts-app/remove-contact', {
// 			contactId
// 		});

// 		return request.then(response =>
// 			Promise.all([
// 				dispatch({
// 					type: REMOVE_CONTACT
// 				})
// 			]).then(() => dispatch(getMembers(routeParams)))
// 		);
// 	};
// }

// export function removeContacts(contactIds) {
// 	return (dispatch, getState) => {
// 		const { routeParams } = getState().addmemberUsersApp.contacts;

// 		const request = axios.post('/api/contacts-app/remove-contacts', {
// 			contactIds
// 		});

// 		return request.then(response =>
// 			Promise.all([
// 				dispatch({
// 					type: REMOVE_CONTACTS
// 				})
// 			]).then(() => dispatch(getMembers(routeParams)))
// 		);
// 	};
// }

// export function toggleStarredContact(contactId) {
// 	return (dispatch, getState) => {
// 		const { routeParams } = getState().addmemberUsersApp.contacts;

// 		const request = axios.post('/api/contacts-app/toggle-starred-contact', {
// 			contactId
// 		});

// 		return request.then(response =>
// 			Promise.all([
// 				dispatch({
// 					type: TOGGLE_STARRED_CONTACT
// 				}),
// 				dispatch(getUserData())
// 			]).then(() => dispatch(getMembers(routeParams)))
// 		);
// 	};
// }

// export function toggleStarredContacts(contactIds) {
// 	return (dispatch, getState) => {
// 		const { routeParams } = getState().addmemberUsersApp.contacts;

// 		const request = axios.post('/api/contacts-app/toggle-starred-contacts', {
// 			contactIds
// 		});

// 		return request.then(response =>
// 			Promise.all([
// 				dispatch({
// 					type: TOGGLE_STARRED_CONTACTS
// 				}),
// 				dispatch(getUserData())
// 			]).then(() => dispatch(getMembers(routeParams)))
// 		);
// 	};
// }

// export function setContactsStarred(contactIds) {
// 	return (dispatch, getState) => {
// 		const { routeParams } = getState().addmemberUsersApp.contacts;

// 		const request = axios.post('/api/contacts-app/set-contacts-starred', {
// 			contactIds
// 		});

// 		return request.then(response =>
// 			Promise.all([
// 				dispatch({
// 					type: SET_CONTACTS_STARRED
// 				}),
// 				dispatch(getUserData())
// 			]).then(() => dispatch(getMembers(routeParams)))
// 		);
// 	};
// }

// export function setContactsUnstarred(contactIds) {
// 	return (dispatch, getState) => {
// 		const { routeParams } = getState().addmemberUsersApp.contacts;

// 		const request = axios.post('/api/contacts-app/set-contacts-unstarred', {
// 			contactIds
// 		});

// 		return request.then(response =>
// 			Promise.all([
// 				dispatch({
// 					type: SET_CONTACTS_STARRED
// 				}),
// 				dispatch(getUserData())
// 			]).then(() => dispatch(getMembers(routeParams)))
// 		);
// 	};
// }
